import React from 'react';
import {
	Breadcrumbs, BreadcrumbsText, Link, Option,
	Tooltip,
	UserInterfaceInfoCircleFill,
	Children
} from 'neon-design-system';
import { makeStyles, createStyles } from '@material-ui/core';
import { ChannelSubscriptionTypeByPayment } from '../../../../shared/types';
import { ManageTemplateInstance} from '../../../ui/ManageTemplate';
import { baseUrls } from '../../../../utils/baseUrls.utils';
import { FormControl } from '../../../../utils/form.utils';
import { ChannelSubscribedUser, ChannelSubscriberAddEditFragment} from '../../../../gql/channels';
import { BulkChannelSubscriptionsInput } from '../../../../gql/subscriptions';

export interface PremiumChannelsSubscribersFormInterface {
	channel: ChannelSubscriberAddEditFragment;
	channelId: string;
	userFormControl: FormControl<Option | undefined>;
	notesFormControl: FormControl<string>;
	fileFormControl: FormControl<File | undefined>;
	returnUrl: string;
	isEdit: boolean;
	isBulk: boolean;
	proceedBulk: (values: BulkChannelSubscriptionsInput) => void;
	usersField: Children;
	notesField: Children;
	currentUser: ChannelSubscribedUser | undefined;
	onDelete: () => void;
}

export const NOTES_CHAR_LIMIT = 250;

export const styles = makeStyles(theme => createStyles({
	container: {
		display: 'flex',
		justifyContent: 'center',
		width: '100%',
		paddingLeft: theme.spacing(2),
		paddingRight: theme.spacing(2),
		paddingBottom: theme.spacing(6)
	},
	main: {
		flex: 1,
		flexDirection: 'column',
		maxWidth: 1200
	},
	helperText: {
		maxWidth: 384, // to match the edit fields in ManageTemplate
		marginBottom: theme.spacing(2)
	},
	labelRadioButton: {
		fontWeight: 'bold',
		marginBottom: theme.spacing(1)
	},
	// Radio component only supports text labels so need to manually position the trailing tooltips
	tooltipWrapper: {
		display: 'inline',
		position: 'relative',
		top: '3px',
		right: '10px',
		maxWidth: 150
	}
}));

export const getPremiumChannelsSubscribersFormInstance = (isBulk: boolean) => isBulk ? ManageTemplateInstance.ChannelSubscribers : ManageTemplateInstance.ChannelSubscriber
export const getPremiumChannelsSubscribersFormCreateButtonLabel = (isBulk: boolean) => isBulk ? 'Subscribe users' : 'Subscribe user'
export const premiumChannelsSubscribersFormUpdateButtonLabel = 'Save';
export const premiumChannelsSubscribersFormDeleteButtonLabel = 'Remove subscriber';
export const premiumChannelsSubscribersFormDeleteDialogTitle = 'Remove';
export const getPremiumChannelsSubscribersFormBreadCrumbs = (channelName: string, returnUrl: string, isEdit: boolean, isBulk: boolean) => (
	<Breadcrumbs>
		<Link to={baseUrls.publisher.premiumChannels.list}>Channels</Link>
		<Link to={returnUrl}>{channelName}</Link>
		<BreadcrumbsText>{isEdit ? 'Edit subscriber settings' : isBulk ? 'Add subscribers' : 'New subscriber'}</BreadcrumbsText>
	</Breadcrumbs>
)

export const isPaidSubscriptionTypeByPayment = (subscriptionTypeValue: ChannelSubscriptionTypeByPayment | undefined) => subscriptionTypeValue === ChannelSubscriptionTypeByPayment.Paid;
export const isFreeSubscriptionTypeByPayment = (subscriptionTypeValue: ChannelSubscriptionTypeByPayment | undefined) => subscriptionTypeValue === ChannelSubscriptionTypeByPayment.Free;
export const isFreeTrialSubscriptionTypeByPayment = (subscriptionTypeValue: ChannelSubscriptionTypeByPayment | undefined) => subscriptionTypeValue === ChannelSubscriptionTypeByPayment.FreeTrial;

export const SubscriptionTypeTooltip = ({ tooltipText }: { tooltipText: string }) => {
	const classes = styles();
	return (
		<Tooltip title={tooltipText} position="right">
			<div className={classes.tooltipWrapper}>
				<UserInterfaceInfoCircleFill size="small" />
			</div>
		</Tooltip>
	)
}
